import * as angular from "angular";
import {IController, ILogService, IScope, ITimeoutService} from "angular";
import * as _ from "lodash";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {Subscription} from "rxjs";

export class ServiceInfoCardController implements IController {

  service: any;
  billing: any;

  public hasRelations: boolean;
  private taskColorByPurpose: any;
  private serviceSubscription: Subscription;

  /* @ngInject */
  constructor(private tasksConstants,
              private deliveriesDialogService: DeliveriesDialogService,
              private $log: ILogService,
              private $delivery,
              private $scope: IScope,
              private tasksService: TasksService,
              private servicesFacadeService: ServicesFacadeService,
              private $timeout: ITimeoutService) {
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
  }

  $onInit() {
    if (this.service) {
      this.hasRelations = !!_.compact(_.flatMap(this.service.taskList || [], 'relations')).length;
      this.servicesFacadeService.setMany([this.service]);
      this.serviceSubscription = this.servicesFacadeService.selectOne(this.service.id).subscribe((service) => {
        this.service = angular.copy(service);
        this.$timeout(() => {
        }, 0)
      })
    }
  }

  $onDestroy() {
    this.serviceSubscription.unsubscribe();
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceInfoCard', {
    bindings: {
      service: '<',
      billing: '<'
    },
    template: require('./service-info-card.html').default,
    controller: ServiceInfoCardController
  });
